module.exports = __webpack_public_path__ + "img/sc4.bf681f57.png";